var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blog",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7148 0L2.28516 0C1.02512 0 0 1.02512 0 2.28516L0 23.7148C0 24.9749 1.02512 26 2.28516 26L23.7148 26C24.9749 26 26 24.9749 26 23.7148L26 2.28516C26 1.02512 24.9749 0 23.7148 0L23.7148 0ZM24.4766 23.7148C24.4766 24.1349 24.1349 24.4766 23.7148 24.4766L2.28516 24.4766C1.86514 24.4766 1.52344 24.1349 1.52344 23.7148L1.52344 7.61719L24.4766 7.61719L24.4766 23.7148L24.4766 23.7148ZM24.4766 6.09375L1.52344 6.09375L1.52344 2.28516C1.52344 1.86514 1.86514 1.52344 2.28516 1.52344L23.7148 1.52344C24.1349 1.52344 24.4766 1.86514 24.4766 2.28516L24.4766 6.09375L24.4766 6.09375Z",
    id: "Shape",
    fill: "#AFAFAF",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.046875 3.046875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.761719C0 0.341033 0.341033 0 0.761719 0C1.1824 0 1.52344 0.341033 1.52344 0.761719C1.52344 1.1824 1.1824 1.52344 0.761719 1.52344C0.341033 1.52344 0 1.1824 0 0.761719Z",
    id: "Circle",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.09375 3.046875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.761719C0 0.341033 0.341033 0 0.761719 0C1.1824 0 1.52344 0.341033 1.52344 0.761719C1.52344 1.1824 1.1824 1.52344 0.761719 1.52344C0.341033 1.52344 0 1.1824 0 0.761719Z",
    id: "Circle",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.140625 3.046875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.761719C0 0.341033 0.341033 0 0.761719 0C1.1824 0 1.52344 0.341033 1.52344 0.761719C1.52344 1.1824 1.1824 1.52344 0.761719 1.52344C0.341033 1.52344 0 1.1824 0 0.761719Z",
    id: "Circle",
    fill: "#AFAFAF",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.046875 9.140625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.37891 0L0.761719 0C0.341047 0 0 0.341047 0 0.761719L0 6.95703C0 7.3777 0.341047 7.71875 0.761719 7.71875L8.37891 7.71875C8.79958 7.71875 9.14063 7.3777 9.14063 6.95703L9.14063 0.761719C9.14063 0.341047 8.79958 0 8.37891 0L8.37891 0ZM7.61719 6.19531L1.52344 6.19531L1.52344 1.52344L7.61719 1.52344L7.61719 6.19531L7.61719 6.19531Z",
    id: "Shape",
    fill: "#AFAFAF",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(13.7109375 15.3359375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48047 0L0.761719 0C0.341047 0 0 0.341047 0 0.761719C0 1.18239 0.341047 1.52344 0.761719 1.52344L8.48047 1.52344C8.90114 1.52344 9.24219 1.18239 9.24219 0.761719C9.24219 0.341047 8.90114 0 8.48047 0L8.48047 0Z",
    id: "Shape",
    fill: "#AFAFAF",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(13.7109375 12.238281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48047 0L0.761719 0C0.341047 0 0 0.341047 0 0.761719C0 1.18239 0.341047 1.52344 0.761719 1.52344L8.48047 1.52344C8.90114 1.52344 9.24219 1.18239 9.24219 0.761719C9.24219 0.341047 8.90114 0 8.48047 0L8.48047 0Z",
    id: "Shape",
    fill: "#AFAFAF",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.046875 18.382812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1445 0L0.761719 0C0.341047 0 0 0.341047 0 0.761719C0 1.18239 0.341047 1.52344 0.761719 1.52344L19.1445 1.52344C19.5652 1.52344 19.9063 1.18239 19.9063 0.761719C19.9063 0.341047 19.5652 0 19.1445 0L19.1445 0Z",
    id: "Shape",
    fill: "#AFAFAF",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.046875 21.429688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1445 0L0.761719 0C0.341047 0 0 0.341047 0 0.761719C0 1.18239 0.341047 1.52344 0.761719 1.52344L19.1445 1.52344C19.5652 1.52344 19.9063 1.18239 19.9063 0.761719C19.9063 0.341047 19.5652 0 19.1445 0L19.1445 0Z",
    id: "Shape",
    fill: "#AFAFAF",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.6584cb0a3e1c7df905034c6517fbf330.svg";
export { ForwardRef as ReactComponent };